import type { LocaleMorpheus } from "@solvari/translations";

import type { Redirect } from "~/shared/libs/redirectMatching.ts";

// Permanent redirects whose path holds a dynamic slug; hardcoded because a dynamic_routes row cannot carry one.
const hardcodedRedirectsByLocale: Record<LocaleMorpheus, Redirect[]> = {
  "be-FR": [
    { from: "^/fr/([^/]+)/demandes-devis$", to: "/fr/$1/devis", type: 301 },
    {
      from: "^/fr/presentation-des-entreprises/([^/]+)/brochure(?:/.*)?$",
      to: "/fr/presentation-des-entreprises/$1",
      type: 301,
    },
  ],
  "be-NL": [
    {
      from: "^/nl/([^/]+)/offertes-aanvragen$",
      to: "/nl/$1/offerte",
      type: 301,
    },
    {
      from: "^/nl/bedrijven-overzicht/([^/]+)/brochure(?:/.*)?$",
      to: "/nl/bedrijven-overzicht/$1",
      type: 301,
    },
  ],
  "dk-DA": [
    { from: "^/([^/]+)/tilbudsanmodninger$", to: "/$1/tilbud", type: 301 },
    {
      from: "^/virksomhedsoversigt/([^/]+)/brochure(?:/.*)?$",
      to: "/virksomhedsoversigt/$1",
      type: 301,
    },
  ],
  "fr-FR": [
    { from: "^/([^/]+)/demandes-devis$", to: "/$1/devis", type: 301 },
    {
      from: "^/presentation-des-entreprises/([^/]+)/brochure(?:/.*)?$",
      to: "/presentation-des-entreprises/$1",
      type: 301,
    },
  ],
  "nl-NL": [
    { from: "^/([^/]+)/offertes-aanvragen$", to: "/$1/offerte", type: 301 },
    {
      from: "^/bedrijven-overzicht/([^/]+)/brochure(?:/.*)?$",
      to: "/bedrijven-overzicht/$1",
      type: 301,
    },
  ],
  "se-SV": [
    { from: "^/([^/]+)/offertforfragningar$", to: "/$1/offert", type: 301 },
    {
      from: "^/foretagsoversikt/([^/]+)/brochure(?:/.*)?$",
      to: "/foretagsoversikt/$1",
      type: 301,
    },
  ],
};

// Spread here, not in the middleware where Redirect is `any` and the spread trips the unsafe-assignment lint.
function withHardcodedRedirects(
  redirects: Redirect[],
  locale: LocaleMorpheus,
): Redirect[] {
  return [...redirects, ...hardcodedRedirectsByLocale[locale]];
}

export { withHardcodedRedirects };
